const navs = [
    {name: "labels.firmware", url: "/advanced/firmware/", icon: "heart-pulse", role: "superadmin"},
    {name: "labels.update", url: "/advanced/updates/", icon: "cloud-arrow-up", role: "superadmin"},
    {name: "labels.pga", url: "/advanced/pga/", icon: "microchip", role: "superadmin", models: ["MQ2-4G"]},
    {name: "labels.networks", url: "/advanced/networks/", icon: "network-wired", role: "superadmin"},
    {name: "labels.mqtt", url: "/advanced/mqtt/", icon: "ethernet", role: "superadmin"},
    {name: "labels.ntp", url: "/advanced/ntp/", icon: "fa-regular fa-clock", role: "superadmin"},
    {name: "labels.gps", url: "/advanced/gps/", icon: "earth-europe", role: "superadmin"},
    {name: "labels.config", url: "/advanced/configs/", icon: "gear", role: "superadmin"},
    {name: "labels.send", url: "/advanced/sender/", icon: "fa-regular fa-paper-plane", role: "superadmin"},

];

export default navs;
